<template>
  <div v-show="styleObj.left !== -10">
    <div class="do-scheduler__line" :style="[
    {left: styleObj.left + 'px'},
    {backgroundColor: this.styleObj.color}
    ]"></div>
    <div class="do-scheduler__line" :style="[
    {right: styleObj.right + 'px'},
    {backgroundColor: this.styleObj.color}
    ]"></div>
  </div>
</template>

<script>
  export default {
    props: {
      lesson: {
        type: Object,
        default: null
      }
    },
    computed: {
      styleObj () {
        return this.lesson ? this.lesson : this.$store.state.subs.schedulerActiveEvent
      }
    }
  }
</script>

<style scoped>
  .do-scheduler__line {
    position: absolute;
    top:0;
    z-index: 3;
    bottom: 0;
    width: 2px;
  }
</style>



// WEBPACK FOOTER //
// SchedulerRulers.vue?7e40f458